/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * API version of an appointment session.
 */
export interface AppointmentSession {
  startTime: string;
  endTime: string;
}
